import type { CopyLang } from "./copyTypes";

export interface LocaleHints {
  hostname?: string | null;
  mountLocale?: string | null;
  htmlLang?: string | null;
  queryLang?: string | null;
}

export class LocaleResolver {
  private static readonly ALIASES: Record<string, CopyLang> = {
    en: "en",
    us: "en",
    nl: "nl",
    be: "nl",
    de: "de",
    es: "es",
    fi: "fi",
    fr: "fr",
    hr: "hr",
    hu: "hu",
    it: "it",
    sl: "sl",
    si: "sl",
    sk: "sk",
    zh: "zh",
    cn: "zh",
  };

  private static readonly HOST_LANGUAGES: Record<string, CopyLang> = {
    "neelevat.com": "en",
    "neelevat.nl": "nl",
    "neelevat.be": "nl",
    "neelevat.de": "de",
    "neelevat.es": "es",
    "neelevat.fi": "fi",
    "neelevat.fr": "fr",
    "neelevat.hr": "hr",
    "neelevat.hu": "hu",
    "neelevat.it": "it",
    "neelevat.si": "sl",
    "neelevat.sk": "sk",
    "neelevat.cn": "zh",
  };

  resolve(hints: LocaleHints): CopyLang {
    return (
      this.languageForHostname(hints.hostname) ??
      this.normalize(hints.queryLang) ??
      this.normalize(hints.htmlLang) ??
      this.normalize(hints.mountLocale) ??
      "en"
    );
  }

  normalize(raw: string | null | undefined): CopyLang | null {
    if (!raw) return null;
    const base = raw.trim().replace(/_/g, "-").toLowerCase().split("-")[0];
    return LocaleResolver.ALIASES[base] ?? null;
  }

  private languageForHostname(hostname: string | null | undefined): CopyLang | null {
    if (!hostname) return null;
    const host = hostname.toLowerCase().replace(/^www\./, "");
    return LocaleResolver.HOST_LANGUAGES[host] ?? null;
  }
}
